import React from "react";
import { Row, Col } from "antd";
import DashBoard from "../../components/DashBoard/DashBoard";
import styles from "../../components/DashBoard/DashBoard.module.scss";
import DashBoardMobile from "../../components/DashBoard/DashBoardMobile/DashBoardMobile";

type Props = {};

const ProfileContainer: React.FC<Props> = () => {
  return (
    <Row>
      <Col  lg={24} className= {styles.dashContainer}>
        <DashBoard />
      </Col>
    </Row>
  );
};

export default ProfileContainer;
